export enum TargetsActionTypes {
    API_RESPONSE_SUCCESS = '@@targets/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@targets/API_RESPONSE_ERROR',

    GET_QUARTERLY_TARGETS = '@@targets/GET_QUARTERLY_TARGETS',
    ADD_QUARTERLY_TARGETS = '@@targets/ADD_QUARTERLY_TARGETS',
    UPDATE_QUARTERLY_TARGETS = '@@targets/UPDATE_QUARTERLY_TARGETS',
    DELETE_QUARTERLY_TARGETS = '@@targets/DELETE_QUARTERLY_TARGETS',

}